import React from "react";
import GenericCard from "@ui-components/Card/GenericCard";
import { SkeletonTableRows } from "@ui-components/Skeleton/GenericSkeleton";

export const RulesSectionSkeleton: React.FC<{ title: string }> = ({ title }) => (
  <div className="my-2">
    <GenericCard
      headerContent={title}
      isCollapsible
      initialExpanded
      bodyContent={
        <div className="space-y-4" aria-busy="true">
          <div
            className="h-10 max-w-[21rem] rounded bg-semantic-bg-secondary animate-pulse"
            aria-hidden
          />
          <SkeletonTableRows rows={5} cols={1} rowHeight={18} animated />
        </div>
      }
    />
  </div>
);

export function OrganizationalNotificationsSkeleton() {
  return (
    <div className="space-y-2">
      <RulesSectionSkeleton title="Port Rules" />
      <RulesSectionSkeleton title="Internet Rules" />
    </div>
  );
}

export function MyNotificationsInitialSkeleton() {
  return (
    <div className="space-y-2">
      <GenericCard
        headerContent="Organizational Configuration"
        isCollapsible={false}
        rightContent={
          <span
            className="inline-block h-7 w-20 rounded-full bg-semantic-bg-secondary animate-pulse"
            aria-hidden
          />
        }
        bodyContent={
          <div className="space-y-3" aria-busy="true">
            <span className="block h-4 w-full rounded bg-semantic-bg-secondary animate-pulse" aria-hidden />
            <span className="block h-4 w-[90%] rounded bg-semantic-bg-secondary animate-pulse" aria-hidden />
            <span className="block h-16 w-full rounded bg-semantic-bg-secondary animate-pulse" aria-hidden />
          </div>
        }
      />
      <OrganizationalNotificationsSkeleton />
    </div>
  );
}
